import {
  INotificationSettingsFromBackend,
  INotificationSettingsFrontendMezzo,
  INotificationSettingsFrontendNCentral,
  // @ts-ignore -- TS5: index access on typed object (was suppressed by suppressImplicitAnyIndexErrors)
} from '@app/@types/notifications'
import {
  mainEventsSettings,
  mainEventsSettingsNCentral,
  systemEventsSettings,
  zoneEventsSettings,
} from '@app/lib/NotificationsSettings/notificationsSettings'

export const filterNotificationSettings = (notificationSettings: INotificationSettingsFromBackend, isNCentral: boolean): INotificationSettingsFrontendMezzo | INotificationSettingsFrontendNCentral | {} => {
  const fieldsArr = isNCentral
    ? [...mainEventsSettingsNCentral, ...zoneEventsSettings, ...systemEventsSettings]
    : [...mainEventsSettings, ...zoneEventsSettings, ...systemEventsSettings]
    // @ts-ignore -- TS5: index access on typed object (was suppressed by suppressImplicitAnyIndexErrors)
  const result = {}
  fieldsArr.forEach((el) => {
    // @ts-ignore TS5: index expression on typed object
    result[el] = notificationSettings[el]
  })
  return result
}
